import MultimediaImg from '../assets/image/Multimedia.png';
import SEOImg from '../assets/image/SEO.png';
import SMMImg from '../assets/image/SMM.png';
import WebDevelopmentImg from '../assets/image/Web-Development.png';

export const homeServices = [
  { title: 'Web Development', img: WebDevelopmentImg },
  { title: 'Multimedia', img: MultimediaImg },
  { title: 'SEO Services', img: SEOImg },
  { title: 'SMM Services', img: SMMImg },
];
